

import apiClient from 'api/apiClient';

export async function getLeaderboard ( level )
{
    return apiClient.get ( "/leaderboard/" + level, 
                { 
                    headers: { 
                        "Content-Type": "application/json" } 
                } );
}